import { render, staticRenderFns } from "./choose-agency.vue?vue&type=template&id=3bfba4b4&scoped=true"
import script from "./choose-agency.vue?vue&type=script&lang=js"
export * from "./choose-agency.vue?vue&type=script&lang=js"
import style0 from "./choose-agency.vue?vue&type=style&index=0&id=3bfba4b4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfba4b4",
  null
  
)

export default component.exports